import React, { useEffect } from 'react';
import { CollapseBlock, Spinner } from '../../../../common';
import {
  useDeleteUsefulLinkMutation,
  useGetUsefulLinksQuery,
} from '../../../../../redux/services/useful_links.jsx';
import { routes } from '../../../../../utils/helpers/ApiClient';
import UsefulLinksTable from './UsefulLinksTable.jsx';
import { AppBarCMS } from '../../../../basic';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useToastMessages } from '../../../../../hooks/useToastMessages';

const UsefulLinksPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    document.title = t('Užitočné odkazy') + ' - FRI CMS';
  }, []); // Runs on mount

  const { deleteSuccess: showDeleteSuccess } = useToastMessages();

  const { data: links, isLoading, refetch } = useGetUsefulLinksQuery();

  const [deleteUsefulLink, { isSuccess: isDeleteSuccess }] =
    useDeleteUsefulLinkMutation();

  useEffect(() => {
    if (isDeleteSuccess) {
      showDeleteSuccess();
      refetch();
    }
  }, [isDeleteSuccess]);

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={t('Užitočné odkazy')}
        backUrl={routes.cmsDashboard}
        backUrlTooltip={t('Nástenka')}
        createText={t('Pridať užitočný odkaz')}
        createUrl={routes.cmsUsefulLinksCreate}
        permissionsBasic="useful-links"
      />
      <div style={{ margin: '10px' }}>
        <CollapseBlock>
          <UsefulLinksTable
            links={links}
            onDelete={(record) => deleteUsefulLink(record.id)}
            onDetailClick={(record) =>
              navigate(`${routes.cmsUsefulLinksEdit}/${record.id}`)
            }
          />
        </CollapseBlock>
      </div>
    </>
  );
};

export default UsefulLinksPage;
